module.exports = __webpack_public_path__ + "static/banner-sm-2d30714b71bdaeea282e7e157537b6c7.jpg";